export const connection = {
    server: document._portalConfig.crmServer,
    apiKeyPlugin: document._portalConfig.apiKeyPlugin,
    urlPlugin: document._portalConfig.urlPlugin,
    urlPaygate: document._portalConfig.urlPaygate,
    apiKeyPaygate: document._portalConfig.apiKeyPaygate,
    urlFormPaygate: document._portalConfig.urlFormPaygate,
    paygateIntegration: document._portalConfig.paygateIntegrationId,
}

export const period = [{id:'2020',name:"2020"},{id:'2021',name:"2021"},{id:'2022',name:"2022"}]

export const colors = [
    'rgba(255, 99, 132, 0.8)',
    'rgba(54, 162, 235, 0.8)',
    'rgba(255, 206, 86, 0.8)',
    'rgba(75, 192, 192, 0.8)',
    'rgba(153, 102, 255, 0.8)',
    'rgba(255, 159, 64, 0.8)',
]

export const colorsDarker = [
    'rgba(255, 99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)',
    'rgba(153, 102, 255, 1)',
    'rgba(255, 159, 64, 1)',
]

export const portalCfg = {
    basename: '',
    publicPath: '', //set to /web or /uat when deploy
    currencyDefault: 'R',
}